// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para o componente de Distribuição de Receita */
.report-revenue-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
.table-responsive {
  overflow-y: auto;
}
.list-medical {
}
.list-medical-v2 {
  height: 570px;
}

.list-medical-v2-all {
  height: 100%;
}

.report-revenue-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 15px;
}

.report-revenue-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

.report-revenue-filters {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.report-revenue-input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: border-color 0.3s ease;
}

.report-revenue-input:focus {
  outline: none;
  border-color: #3498db;
}

.report-revenue-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.report-revenue-button:hover {
  background-color: #2980b9;
}

.report-revenue-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.report-revenue-table thead {
  background-color: #f8f9fa;
}

.report-revenue-table th {
  padding: 15px;
  text-align: left;
  color: #6c757d;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
}

.report-revenue-table td {
  padding: 15px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}

.report-revenue-table tr:hover {
  background-color: #f1f3f5;
}

.report-revenue-income {
  color: #28a745;
  font-weight: bold;
}

.report-revenue-expense {
  color: #dc3545;
  font-weight: bold;
}

.report-revenue-back-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.report-revenue-back-button:hover {
  background-color: #545b62;
}

/* Responsividade */
@media (max-width: 768px) {
  .report-revenue-filters {
    flex-direction: column;
  }

  .report-revenue-table {
    font-size: 14px;
  }

  .report-revenue-table th,
  .report-revenue-table td {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/componentCss/ReportRevenueDistributionItem.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;AACA;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Estilos para o componente de Distribuição de Receita */\n.report-revenue-container {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.table-responsive {\n  overflow-y: auto;\n}\n.list-medical {\n}\n.list-medical-v2 {\n  height: 570px;\n}\n\n.list-medical-v2-all {\n  height: 100%;\n}\n\n.report-revenue-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 15px;\n}\n\n.report-revenue-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 24px;\n}\n\n.report-revenue-filters {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.report-revenue-input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  transition: border-color 0.3s ease;\n}\n\n.report-revenue-input:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.report-revenue-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.report-revenue-button:hover {\n  background-color: #2980b9;\n}\n\n.report-revenue-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.report-revenue-table thead {\n  background-color: #f8f9fa;\n}\n\n.report-revenue-table th {\n  padding: 15px;\n  text-align: left;\n  color: #6c757d;\n  font-weight: 600;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.report-revenue-table td {\n  padding: 15px;\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s ease;\n}\n\n.report-revenue-table tr:hover {\n  background-color: #f1f3f5;\n}\n\n.report-revenue-income {\n  color: #28a745;\n  font-weight: bold;\n}\n\n.report-revenue-expense {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.report-revenue-back-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.report-revenue-back-button:hover {\n  background-color: #545b62;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .report-revenue-filters {\n    flex-direction: column;\n  }\n\n  .report-revenue-table {\n    font-size: 14px;\n  }\n\n  .report-revenue-table th,\n  .report-revenue-table td {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
